import { UserFeatureFlag } from '@app/types';
import { getLocalStorage, setLocalStorage } from '@app/utilities';

/** Service to handle feature flag related actions. */
export class FeatureFlagService {
  /** Checks if a feature is on (`true`) or off (`false`). */
  isFeatureOn(flag: UserFeatureFlag): boolean {
    const key = `flag-${flag}`;
    return getLocalStorage(key, () => false);
  }

  /** Sets whether a feature is on (`true`) or off (`false`). */
  setFeature(flag: UserFeatureFlag, value: boolean): boolean {
    const key = `flag-${flag}`;
    return setLocalStorage(key, value);
  }
}
